import QuickTagDatasetPage from './QuickTagDatasetPage';
import QuickTagCodeframePage from './QuickTagCodeframePage';
import QuickTagConfigPage from './QuickTagConfigPage';

export { QuickTagDatasetPage, QuickTagCodeframePage, QuickTagConfigPage };
